import { FormattedMessage } from 'react-intl';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function ErrorState(): JSX.Element {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-red-600">
          <FormattedMessage id="integrations.messaging.slack.error.title" />
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-gray-600">
          <FormattedMessage id="integrations.messaging.slack.error.description" />
        </p>
      </CardContent>
    </Card>
  );
}
